import { useTranslation } from "react-i18next";

export const MEETING_TYPES = ["employee_interview", "project_meeting", "other"];

export function MeetingMinutesTypePills({ value, onChange, allowEmpty = false }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-2">
      {allowEmpty ? (
        <button
          type="button"
          onClick={() => onChange("")}
          className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
            !value
              ? "bg-[linear-gradient(135deg,#1463C7,#2D8BE8)] text-white shadow-[0_6px_14px_-5px_rgba(20,99,199,.6)]"
              : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          }`}
        >
          {t("meeting_minutes.filter.all_types")}
        </button>
      ) : null}
      {MEETING_TYPES.map((type) => (
        <button
          key={type}
          type="button"
          onClick={() => onChange(type)}
          className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
            value === type
              ? "bg-[linear-gradient(135deg,#1463C7,#2D8BE8)] text-white shadow-[0_6px_14px_-5px_rgba(20,99,199,.6)]"
              : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          }`}
        >
          {t(`meeting_minutes.type.${type}`)}
        </button>
      ))}
    </div>
  );
}

export function meetingTypeLabel(t, type) {
  if (!type) return "";
  return t(`meeting_minutes.type.${type}`, { defaultValue: type });
}
